import { axiosPrivate } from "./AxiosPrivate";

export const getAllCategory = () => axiosPrivate.get("/admin/get-all-category");
export const createCategory = (data) => axiosPrivate.post("/admin/create-category", data);
export const createSubcategory = (data) => axiosPrivate.post("/admin/create-subcategory", data);
export const updateCategory = (id, data) => axiosPrivate.put(`/admin/update-category/${id}`, data);
export const updateSubcategory = (id, data) => axiosPrivate.put(`/admin/update-subcategory/${id}`, data);
/* ----------------------------------- new ---------------------------------- */
export const getSurveyorSurveys = (id, paramsData) =>
  axiosPrivate.get(`/admin/getSurveyorSurveys/${id}`, { params: paramsData });
export const getSingleSurveyorProfile = (bidID) =>
  axiosPrivate.get(`/admin/getSingleSurveyorProfile/${bidID}`);
export const getSurveyAssignedSurveyor = (id) =>
  axiosPrivate.get(`/admin/getSurveyAssignedSurveyor/${id}`);

export const addBid = (data) =>
  axiosPrivate.post("/admin/add-bid", data);

export const updateBid = (id, data) =>
  axiosPrivate.put(`/admin/update-bid/${id}`, data);

export const getSingleBidDetails1 = (id) =>
  axiosPrivate.get(`/admin/get-single-bid/${id}`);

export const createBid = (data) =>
  axiosPrivate.post(`/admin/create-bid`, data);

//Dashboard

export const getDashboard = () =>
  axiosPrivate.get("/admin/get-dashboard");

//Individual Buyer Request

export const getAllBuyer = (paramsData) =>
  axiosPrivate.get("/admin/getAllBuyer", { params: paramsData });
export const updateBuyerStatus = (id, status) =>
  axiosPrivate.put(`/admin/updateBuyerStatus/${id}`, { status });
export const getVerifyBuyerRequest = (paramsData) =>
  axiosPrivate.get("/admin/getVerifyBuyerRequest", { params: paramsData });
export const getSingleBuyer = (id) =>
  axiosPrivate.get(`/admin/getSingleBuyer/${id}`);



export const verifyBuyer = (id) =>
  axiosPrivate.put(`/admin/verify-buyer/${id}`);
export const rejectBuyerVerification = (id, rejectReason) =>
  axiosPrivate.put(`/admin/reject-buyer-verification/${id}`, { rejectReason });

export const getBidHistory = (buyerID) =>
  axiosPrivate.get(`/admin/getBidHistory/${buyerID}`);
export const getTransactionHistory = (buyerID) =>
  axiosPrivate.get(`/admin/getTransactionHistory/${buyerID}`);

//Group Request
export const getAllGroup = (paramsData) =>
  axiosPrivate.get("/admin/getAllGroup", { params: paramsData });
export const getSingleGroup = (id) =>
  axiosPrivate.get(`/admin/getSingleGroup/${id}`);
export const createGroup = (data) =>
  axiosPrivate.post("/admin/create-group", data);
export const updateGroup = (id, data) =>
  axiosPrivate.put(`/admin/update-group/${id}`, data);

export const getAllMembers = (groupID, paramsData) =>
  axiosPrivate.get(`/admin/get-group-members/${groupID}`, {
    params: paramsData,
  });
export const getCompanyBuyer = (paramsData) =>
  axiosPrivate.get(`/admin/get-company-buyer/`, { params: paramsData });

export const addGroupMember = (groupID, data) =>
  axiosPrivate.put(`/admin/add-members-to-group/${groupID}`, data);
export const removeGroupMember = (groupID, data) =>
  axiosPrivate.put(`/admin/remove-group-member/${groupID}`, data);
export const getAllGroupBids = (groupID, paramsData) =>
  axiosPrivate.get(`/admin/get-group-bid/${groupID}`, { params: paramsData });

//Content Manage Request
export const addCompanyProfile = (formData) =>
  axiosPrivate.post(`/admin/add-company-profile`, formData);
export const getCompanyProfile = () =>
  axiosPrivate.get("/admin/get-company-profile");
export const getAllBanners = () => axiosPrivate.get("/admin/get-all-banners");
export const bannerPublishUpdate = (banner) =>
  axiosPrivate.post("/admin/bannerPublishUpdate", { banner });

export const updateBanner = (id, data) =>
  axiosPrivate.put(`/admin/update-banner/${id}`, data);
export const updateBannerStatus = (id, data) =>
  axiosPrivate.put(`/admin/update-banner-status/${id}`, data);
export const addBanner = (data) => axiosPrivate.post("/admin/add-banner", data);

//Review

export const getAllUserReviews = () => axiosPrivate.get('/admin/get-all-user-review')
export const reviewBulkUpdate = (reviews) => axiosPrivate.post('/admin/review-bulk-update', { reviews });

//Manager Request

export const getAllManager = (paramsData) =>
  axiosPrivate.get("/admin/get-all-manager", { params: paramsData });
export const createManager = (formData) =>
  axiosPrivate.post(`/admin/create-manager`, formData);
export const getSingleManager = (id) =>
  axiosPrivate.get(`/admin/get-single-manager/${id}`);
export const updateManager = (id, formData) =>
  axiosPrivate.put(`/admin/update-manager/${id}`, formData);
export const updateManagerStatus = (id, status) =>
  axiosPrivate.put(`/admin/update-manager-status/${id}`, { status });

//Settings Request
export const updateAdminGeneral = (data) =>
  axiosPrivate.put("/admin/update-admin-general", data);
export const adminChangePassword = (data) =>
  axiosPrivate.put("/admin/change-password", data);
export const updateNotificationPreferences = (data) =>
  axiosPrivate.put("/admin/update-notification-preferences", data);
export const createSubAdmin = (email) =>
  axiosPrivate.post("/admin/create-sub-admin", { email });
export const viewSubAdmin = () => axiosPrivate.get("/admin/get-subadmin-list");
export const removeSubAdminAccess = (id) =>
  axiosPrivate.put(`/admin/remove-subadmin/${id}`);
